import React, { createElement } from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
import { Clock, Zap, Heart, ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
import { CountdownTimer } from './ui/CountdownTimer';
const CHECKOUT_URL = 'https://digitalpremium.online/cart/47709744955618:1';
export function PricingSection() {
  // Precargar el checkout al pasar el mouse / enfocar para que abra al instante
  const prefetchCheckout = () => {
    if (document.getElementById('checkout-prefetch')) return;
    const link = document.createElement('link');
    link.id = 'checkout-prefetch';
    link.rel = 'prefetch';
    link.href = CHECKOUT_URL;
    document.head.appendChild(link);
  };
  return <>
      <SectionWrapper id="pricing" className="text-center px-4 md:px-0" data-id="element-120">
        <div className="bg-[#0d3354] border-2 border-sky-400 rounded-2xl md:rounded-[2rem] p-6 md:p-16 relative shadow-[0_0_40px_rgba(56,189,248,0.15)] max-w-2xl mx-auto w-full" data-id="element-121">
          <div className="absolute -top-4 md:-top-6 left-1/2 -translate-x-1/2 bg-sky-500 text-white px-4 md:px-6 py-1.5 md:py-2 rounded-full font-bold flex items-center gap-1.5 md:gap-2 shadow-lg text-[11px] md:text-base whitespace-nowrap" data-id="element-122">
            <Clock className="w-3.5 h-3.5 md:w-5 md:h-5" data-id="element-123" /> PRECIO DE
            LANZAMIENTO
          </div>

          <div className="mt-6 md:mt-8 mb-6 md:mb-8" data-id="element-124">
            <p className="text-orange-500 font-bold flex items-center justify-center gap-1.5 mb-3 text-xs md:text-base" data-id="element-125">
              ⚠️ Precio actual por tiempo limitado
            </p>

            <CountdownTimer data-id="element-126" />

            <p className="text-base md:text-xl text-slate-400 font-bold mt-4 mb-1" data-id="element-127">
              Antes <span className="line-through decoration-2" data-id="element-128">$39.990</span>
            </p>
            <div className="text-5xl md:text-7xl font-black text-white mb-1 md:mb-4 tracking-tight" data-id="element-129">
              $19.990{' '}
              <span className="text-xl md:text-2xl text-slate-400 font-bold" data-id="element-130">
                ARS
              </span>
            </div>
            <p className="text-sm md:text-xl text-slate-400 font-medium" data-id="element-131">
              👉 Después aumenta{' '}
              <span className="text-red-500 font-bold" data-id="element-132">$20.000</span>. No
              vuelve.
            </p>
          </div>

          <div className="bg-[#0a2c47] rounded-xl md:rounded-2xl p-4 md:p-6 border border-sky-900/40 mb-6 md:mb-10 text-left w-full" data-id="element-133">
            <p className="font-bold text-sky-400 flex items-center gap-2 mb-3 text-sm md:text-base" data-id="element-134">
              <span className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-red-500 animate-pulse" data-id="element-135" />{' '}
              QUÉ INCLUYE TU ACCESO
            </p>
            <ul className="space-y-2" data-id="element-136">
              {['Sistema completo (50 módulos prácticos)', 'Los 6 bonos estratégicos — GRATIS', 'Acceso inmediato en minutos', 'Garantía total de 7 días'].map((item, i) => <li key={i} className="flex items-start gap-2 text-slate-300 text-[13px] md:text-base" data-id="element-137">
                  <ShieldCheck className="w-4 h-4 md:w-5 md:h-5 text-sky-400 shrink-0 mt-0.5" data-id="element-138" />
                  <span data-id="element-139">{item}</span>
                </li>)}
            </ul>
          </div>

          <Button fullWidth className="py-4 md:py-5 text-[15px] md:text-xl" onMouseEnter={prefetchCheckout} onFocus={prefetchCheckout} onClick={() => window.open(CHECKOUT_URL, '_blank')} data-id="element-140">
            QUIERO MI MEGAPACK
          </Button>
        </div>
      </SectionWrapper>

      <SectionWrapper className="px-4 md:px-0" data-id="element-141">
        <div className="grid md:grid-cols-2 gap-4 md:gap-8" data-id="element-142">
          <div className="bg-[#0d3354] shadow-xl rounded-2xl md:rounded-3xl p-6 md:p-10 border border-sky-900/40" data-id="element-143">
            <div className="flex items-center gap-2 md:gap-3 mb-5 md:mb-8" data-id="element-144">
              <Heart className="w-6 h-6 md:w-8 md:h-8 text-red-500" data-id="element-145" />
              <h3 className="text-xl md:text-2xl font-extrabold text-white" data-id="element-146">
                LO QUE MÁS IMPACTA
              </h3>
            </div>
            <p className="text-slate-400 mb-3 md:mb-4 text-sm md:text-base" data-id="element-147">
              Muchos padres creen que:
            </p>
            <p className="text-base md:text-xl font-bold text-white mb-5 md:mb-8 bg-[#0a2c47] p-3 md:p-4 rounded-xl border border-sky-900/40" data-id="element-148">
              👉 "Mi hijo no haría eso"
            </p>
            <p className="text-slate-400 mb-3 md:mb-4 text-sm md:text-base" data-id="element-149">
              Pero la realidad es:
            </p>
            <div className="space-y-2 md:space-y-3" data-id="element-150">
              <p className="text-base md:text-xl font-bold text-sky-400" data-id="element-151">
                👉 No siempre es lo que hace
              </p>
              <p className="text-base md:text-xl font-bold text-sky-400" data-id="element-152">
                👉 Es lo que le pasa
              </p>
            </div>
          </div>

          <div className="bg-[#0d3354] shadow-xl rounded-2xl md:rounded-3xl p-5 md:p-10 border border-sky-900/40" data-id="element-153">
            <div className="flex items-center gap-2 md:gap-3 mb-5 md:mb-8" data-id="element-154">
              <ShieldCheck className="w-6 h-6 md:w-8 md:h-8 text-sky-400" data-id="element-155" />
              <h3 className="text-xl md:text-2xl font-extrabold text-white" data-id="element-156">
                GARANTÍA 7 DÍAS
              </h3>
            </div>
            <div className="space-y-4 md:space-y-6 text-base md:text-lg text-slate-300" data-id="element-157">
              <p className="font-bold text-white text-lg md:text-xl" data-id="element-158">
                Lo leés. Lo aplicás.
              </p>
              <p className="text-sm md:text-base" data-id="element-159">Si no es lo que esperabas:</p>
              <p className="text-base md:text-xl font-bold text-sky-400 bg-sky-400/10 border border-sky-400/20 p-3 md:p-4 rounded-xl inline-block" data-id="element-160">
                👉 devolución total
              </p>
              <p className="text-slate-400 font-medium text-sm md:text-base" data-id="element-161">
                Sin preguntas.
              </p>
            </div>
          </div>
        </div>
      </SectionWrapper>
    </>;
}